import { render } from "./SkillsPage.vue?vue&type=template&id=0eac7362&scoped=true"
import script from "./SkillsPage.vue?vue&type=script&lang=js"
export * from "./SkillsPage.vue?vue&type=script&lang=js"

import "./SkillsPage.vue?vue&type=style&index=0&id=0eac7362&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eac7362"]])

export default __exports__